module.exports = __webpack_public_path__ + "img/play-store.06063625.svg";